import { faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import Avatar from '@scoir/avatar'

import LinkListItem from '../../LinkListItem'

const useStyles = makeStyles((theme) => {
  return {
    icon: {
      color: theme.palette.action.active,
    },
  }
})

const NlpResultComponent = ({ id, label }: { id: string; label: string }) => {
  const classes = useStyles()
  return (
    <LinkListItem
      id={id}
      to={`${import.meta.env.BASE_URL}/discover/search?nlpPrompt=${encodeURIComponent(label)}`}
      label={
        <>
          Search colleges for
          <Box
            component="span"
            fontWeight="fontWeightBold"
          >
            {` "${label}"`}
          </Box>
        </>
      }
      iconComp={
        <Avatar
          size={'sm'}
          fallbackIcon={
            <FontAwesomeIcon
              className={classes.icon}
              size="lg"
              icon={faMagnifyingGlass}
              fixedWidth
            />
          }
        />
      }
      hoverText={`Search colleges for "${label}"`}
    />
  )
}

export default NlpResultComponent
